import React from 'react';

const OddItem = ({oddItem}) => {
    return (
      <div className="oddItem">
        <div className="titleWrapper">
          <div className="titleSection">
            <span className="titleText">{oddItem.title}</span>
            {/* need to check translation */}
            <span className="descriptionText">{oddItem.description}</span>
            {/* need to check translation */}
          </div>
          <div className={`cards ${oddItem.combinations}`}></div>
        </div>
        <span className="amount">{oddItem.amount}</span>
        <span className="max">{oddItem.max}</span>
      </div>
    );
};

export default OddItem;
